/**
 * RealSynq Explorer — Brand Tokens
 *
 * Aligned with the Leanback Intelligence Dashboard design system v2.2.0
 * ("Command Center / Deep Space").
 *
 * Source of truth: docs/DESIGN_SYSTEM.md (LID repo) + docs/DESIGN.md (this repo)
 */

export const COLORS = {
  /** LID navy scale — navy-950 / navy-900 / navy-800 */
  bg: "#060d18",
  bg2: "#0a1628",
  bgElev: "rgba(19, 42, 68, 0.72)",
  bgCard: "rgba(15, 29, 51, 0.78)",
  bgCardSolid: "#0f1d33",

  /** LID-style electric borders — subtle blue tint */
  border: "rgba(59, 130, 246, 0.12)",
  borderHi: "#234a6e",

  /** LID text scale — slate-100 / slate-400 / slate-500 */
  ink: "#f1f5f9",
  inkDim: "#94a3b8",
  inkMute: "#64748b",

  /**
   * Accent ramp.
   * cyan  = RealSynq live-signal indicator (pulse dot, active signal state).
   * blue  = LID electric-500 — primary CTA / active nav (matches LID exactly).
   * Amber/Rose/Violet/Lime/Pink are per-package accents.
   */
  cyan: "#5eead4",
  blue: "#3b82f6",
  amber: "#fbbf24",
  rose: "#fb7185",
  violet: "#a78bfa",
  lime: "#a3e635",
  pink: "#f472b6",
} as const;

/**
 * Brand asset CDN paths.
 * Hosted on inhousevideo.b-cdn.net — managed by the Leanback marketing/brand team.
 */
export const ASSETS = {
  badge: "https://inhousevideo.b-cdn.net/ldb/Leanback_BEST-1-LOGO_BADGE_500x500.png",
  bg: "https://inhousevideo.b-cdn.net/ldb/Leanback_BEST-3-Background_1920x1080.png",
} as const;

/**
 * Typography stack — must match LID design system.
 * Outfit:        display headings
 * DM Sans:       body & UI
 * JetBrains Mono: data values, signal IDs, code
 */
export const FONT_FAMILIES = {
  display: "'Outfit', sans-serif",
  body: "'DM Sans', system-ui, sans-serif",
  mono: "'JetBrains Mono', monospace",
} as const;

/** Responsive breakpoints (px). */
export const BREAKPOINTS = {
  mobile: 768,
  tablet: 1024,
} as const;
